import {createStore} from 'vuex'

export default createStore({
    state: {
        ifMobile: false,
        totalQuizScore: 0,
        showResultScore: false,
        confirmPopup: true,
        gameAnd: false,
        goToFinal: false,
        cookiesPopup: true,
    },
    getters: {
        getIsMobile: state => {
            return state.ifMobile
        },
        getTotalQuizScore: state => {
            return state.totalQuizScore
        },
        getShowResultScore: state => {
            return state.showResultScore
        },
        getGameAnd: state => {
            return state.gameAnd
        },
        getGoToFinal: state => {
            return state.goToFinal
        },
        getConfirmPopup: state => {
            return state.confirmPopup
        },
        getCookiesPopup: state => {
            return state.cookiesPopup
        }
    },
    mutations: {
        setIsMobile(state, mobile) {
            state.ifMobile = mobile
        },
        setTotalQuizScore(state, score) {
            state.totalQuizScore = score
        },
        setShowResultScore(state, show) {
            state.showResultScore = show
        },
        setConfirmPopup(state, confirmPopup) {
            state.confirmPopup = confirmPopup
        },
        setGameAnd(state, GameAnd) {
            state.gameAnd = GameAnd
        },
        setGoToFinal(state, GameAnd) {
            state.goToFinal = GameAnd
        },
        setCookiesPopup(state, cookiesPopup) {
            state.cookiesPopup = cookiesPopup
        }
    },
    actions: {
        switchMobile({commit}, mobile) {
            commit('setIsMobile', mobile)
        },
        switchTotalQuizScore({commit}, score) {
            commit('setTotalQuizScore', score)
        },
        switchShowResultScore({commit}, show) {
            commit('setShowResultScore', show)
        },
        switchConfirmPopup({commit}, confirmPopup) {
            sessionStorage.setItem('confirmPopup', confirmPopup)
            commit('setConfirmPopup', confirmPopup)
        },
        switchGameAnd({commit}, GameAnd) {
            commit('setGameAnd', GameAnd)
        },
        switchGoToFinal({commit}, GameAnd) {
            commit('setGoToFinal', GameAnd)
        },
        switchCookiesPopup({commit}, cookiesPopup) {
            commit('setCookiesPopup', cookiesPopup)
        },
    },
})
